/* eslint-disable import/prefer-default-export */
/* eslint-disable quote-props */
import experimentoteca from './experimentoteca.svg';
import maosNaMatematica from './maosMatematica.svg';
import rodaGigante from './rodaGigante.svg';

interface dataProps {
  [key: string]: string;
}

export const data: dataProps = {
  'secaoExperimentoteca': experimentoteca,
  'secaoMaosNaMatematica': maosNaMatematica,
  'secaoRodaGigante': rodaGigante,
};
